import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useConfigStore } from "@/stores/config";
import { INSPECTION_COMMENTS } from "@/constants/Inspections";
import { getReportFooter, getReportHeader } from "@/reports/ReportUtil";
import { styles } from "@/reports/reportStyles";

function setSignsLightsDocDefinition(structure) {
  const configStore = useConfigStore();
  let docDefinition = {
    header: function () {
      return getReportHeader("Signs & Lights Page", structure);
    },
    footer: function (currentPage, pageCount) {
      return getReportFooter(currentPage, pageCount);
    },
    pageMargins: [20, 70, 20, 50],
    content: [
      { text: "", pageHeaderText: "Signs & Lights Page" },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Sign & Light Conditions",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
      },
      {
        columns: [
          {
            width: "25%",
            text: "SL.20 Overall Condition Rating: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.strRating
            ),
            margin: [0, 5, 0, 0],
          },
        ],
      },
      {
        text: "Overall Sign & Light Notes: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.OVERALL)
          ?.notes,
      },

      {
        columns: [
          {
            width: "25%",
            text: "SL.21 Foundation: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.baseCondRate
            ),
            margin: [0, 5, 0, 0],
          },
          {
            width: "25%",
            text: "SL.26 Lights: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.lightCondRate
            ),
            margin: [0, 5, 0, 0],
          },
        ],
      },
      {
        columns: [
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "SL.22 Guide Rail: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.grailCondRate
            ),
          },
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "SL.27 Surface/Paint: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.surfaceCondRate
            ),
          },
        ],
      },
      {
        columns: [
          {
            margin: [0, 5, 0, 0],
            width: "25%",
            text: "SL.23 Column: ",
            bold: true,
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.columnCondRate
            ),
          },
          {
            width: "25%",
            text: "SL.28 Horiz. Member/Frame: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.horCondRate
            ),
          },
        ],
      },
      {
        columns: [
          {
            width: "25%",
            text: "SL.24 Method of Access: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.accessCondRate
            ),
          },
          {
            width: "25%",
            text: "SL.29 Sign Asset Tag Condition: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_ASSET_TAG,
              structure.signLightInspection.signAssetTag
            ),
          },
        ],
      },
      {
        columns: [
          {
            width: "25%",
            text: "SL.25 Sign: ",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          {
            margin: [0, 5, 0, 0],
            width: "*",
            text: configStore.getReferenceValue(
              REFERENCE_TABLE.SIGN_LIGHT_CONDITION_RATING,
              structure.signLightInspection.signCondRate
            ),
          },
        ],
      },
      {
        table: {
          headerRows: 0,
          widths: ["100%"],
          body: [
            [
              {
                text: "Sign & Light Inspection Notes",
                fillColor: "#ebebeb",
                alignment: "center",
                style: ["sectionHeader"],
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [0, 5, 0, 0],
      },
      {
        text: "Foundation: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_COLUMN_BASE
        )?.notes,
      },
      {
        text: "Guide Rail: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_GUIDE_RAIL
        )?.notes,
      },
      {
        text: "Column: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.SIGN_COLUMN)
          ?.notes,
      },
      {
        text: "Method of Access: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_ACCESS_METH
        )?.notes,
      },
      {
        text: "Sign: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.SIGN_SIGN)
          ?.notes,
      },
      {
        text: "Lights: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find((element) => element?.commentType == INSPECTION_COMMENTS.SIGN_LIGHTS)
          ?.notes,
      },
      {
        text: "Surface/Paint: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_SURFACE_PAINT
        )?.notes,
      },
      {
        text: "Horizontal Member/Frame: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_FRAMEWORK
        )?.notes,
      },
      {
        text: "Sign Asset Tags - Exist/Condition: ",
        bold: true,
        margin: [0, 5, 0, 0],
      },
      {
        text: structure?.inspectionComments?.find(
          (element) => element?.commentType == INSPECTION_COMMENTS.SIGN_ASSET_TAGS
        )?.notes,
      },
    ],
    styles: styles,

    defaultStyle: {
      fontSize: 10,
    },
  };
  return docDefinition;
}

export { setSignsLightsDocDefinition };
